/**
 * Path patterns identifying the direct-lab (labs_self_checkout) flow.
 *
 * Single source of truth for the labs path shape — `@checkout/patient`'s
 * `checkoutRoutes` re-uses these patterns, and `useSelfCheckoutFlow` derives
 * the active flow from them. Lives in `@shared` (the only package both the
 * unauthenticated and checkout bundles may import per the cross-reference
 * rule) so flow resolution never couples the bundles.
 *
 * Matches both surfaces:
 * - unauthenticated Rails entry: /checkout/:store_slug/labs/test|panel/:id
 * - authenticated Remix checkout: /r/checkout/:store_slug/labs/test|panel/:id
 */
const DIRECT_LABS_SELF_CHECKOUT_PATH_PATTERN =
  /\/labs\/(test|panel)\/[^/]+(?:\/(?:payment|sample-collection))?\/?$/;

const CHECKOUT_BASE_PATTERN = /^\/(?:r\/)?checkout\//;

const isDirectLabsSelfCheckoutPathname = (pathname: string): boolean => {
  return (
    CHECKOUT_BASE_PATTERN.test(pathname) && DIRECT_LABS_SELF_CHECKOUT_PATH_PATTERN.test(pathname)
  );
};

export { DIRECT_LABS_SELF_CHECKOUT_PATH_PATTERN, isDirectLabsSelfCheckoutPathname };
